/**
 * Although previousAddress, previousEmploymentDetails, and accountType are dependent
 * on existing field names (currentAddress, employmentDetails, and bankingDetails respectively),
 * they are treated as separate fields by the API for submissions and errors due to these submissions.
 *
 * Since these fields do not correspond to particular panels we map the errors associated with them
 * to the panels to which they are related, so that the correct panel with errors may be opened.
 * @param { string } fieldName
 * @returns { string } The panel to which the error belongs if any. Otherwise the original parameter is returned
 */
export const mapFieldNameToCollapsiblePanel = (fieldName: string): string => {
  switch (fieldName) {
    case 'previousAddress':
      return 'currentAddress';
    case 'previousEmploymentDetails':
      return 'employmentDetails';
    case 'accountType':
      return 'bankingDetails';
    default:
      return fieldName;
  }
};
